<div class="container-fluid">
    <app-page-title title="Account Management"></app-page-title>
    <form [formGroup]="accManageForm" (ngSubmit)="upsert()" (keydown.enter)="useEnterKey ? $event.preventDefault() : upsert()">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="Vendor">Vendor <span class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="Vendor"
                                        formControlName="txtVendor" readonly >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="accCode">Account Code<span class="mandatory">*</span></label>
                                    <input id="accCode" type="text" class="form-control form-control-sm"
                                        formControlName="txtAccCode" maxlength="30" autocomplete="off"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || accManageForm.get('txtAccCode').touched) && accManageForm.get('txtAccCode').errors}"
                                        >
                                    <div *ngIf="(isFormSubmitted || accManageForm.get('txtAccCode').touched) && accManageForm.get('txtAccCode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="accManageForm.get('txtAccCode').errors.required">Account Number is
                                            required</span>
                                        <span *ngIf="accManageForm.get('txtAccCode').errors.maxlength">Max of 30
                                            characters
                                            allowed.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="userId">User Id<span class="mandatory">*</span></label>
                                    <input id="userId" type="text" class="form-control form-control-sm"
                                        formControlName="txtUserId" maxlength="30" autocomplete="off"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || accManageForm.get('txtUserId').touched) && accManageForm.get('txtUserId').errors}"
                                        >
                                    <div *ngIf="(isFormSubmitted || accManageForm.get('txtUserId').touched) && accManageForm.get('txtUserId').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="accManageForm.get('txtUserId').errors.required">User Id is
                                            required</span>
                                        <span *ngIf="accManageForm.get('txtUserId').errors.maxlength">Max of 30
                                            characters
                                            allowed.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="password">Password<span *ngIf="!editMode"
                                            class="mandatory">*</span></label>
                                    <input id="password" type="password" class="form-control form-control-sm"
                                        formControlName="txtPassword" maxlength="30" autocomplete="off"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || accManageForm.get('txtPassword').touched) && accManageForm.get('txtPassword').errors}"
                                        >
                                    <div *ngIf="(isFormSubmitted || accManageForm.get('txtPassword').touched) && accManageForm.get('txtPassword').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="accManageForm.get('txtPassword').errors.required">Password is
                                            required</span>
                                        <span *ngIf="accManageForm.get('txtPassword').errors.pattern">Min of 5 and Max
                                            of 20 characters allowed.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isShowAdditionalDetails">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> Additional Details </div>
                <div class="card-body">
                    <!-- <div class="col-md-2">
                        <div class="mb-2">

                            <label for="customer" class="form-label">Customer <span *ngIf="mandateCustomer"
                                    class="mandatory">*</span></label>
                            <ng-select id="customer" placeholder="Select" [items]="customerList" [appendTo]="'body'" [openOnEnter]="false"
                                formControlName="ddlCustomers" bindLabel="name" [bindValue]="'id'"
                                [ngClass]="{'is-invalid': (isFormSubmitted || accManageForm.get('ddlCustomers').touched) && accManageForm.get('ddlCustomers').errors}"
                                >
                                <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                    <span>{{ item.name }}</span>
                                </ng-template>
                            </ng-select>
                            <div *ngIf="(isFormSubmitted || accManageForm.get('ddlCustomers').touched) && accManageForm.get('ddlCustomers').errors"
                                class="invalid-feedback">
                                <span *ngIf="accManageForm.get('ddlCustomers').errors.required">Customer is Required
                                </span>
                            </div>
                        </div>
                    </div> -->

                    <div class="row" >
                        <form [formGroup]="form">
                            <!-- First section for jsonData -->
                            <div class="row" *ngIf="jsonData">
                              <div class="col-md-2" *ngFor="let key of objectKeys(jsonData ?? {})">
                                <div class="mb-2">
                                  <label [for]="key" class="form-label">{{ key }}</label>
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    [id]="key"
                                    [formControlName]="key"
                                    appEnterDirective
                                    [onEnterKey]="useEnterKey"
                                  />
                                </div>
                              </div>
                            </div>                          
                        </form>                          
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <button type="submit" class="btn btn-primary w-md" appEnterDirective [onEnterKey]="useEnterKey">
                        <span *ngIf="!editMode">Add</span>
                        <span *ngIf="editMode">Update</span>
                    </button>
                    <button type="button" class="btn btn-primary w-md" (click)="resetForm()" appEnterDirective
                        [onEnterKey]="useEnterKey">Reset</button>
                    <a routerLink="/setup/vendors"><button type="button"
                            class="btn btn-secondary w-md">Cancel</button></a>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">Account Details</div>
                <div class="card-body">
                    <div class="col-md-12 grid-container">
                        <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                            [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                            [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                            [pagination]="true" (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>